import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // keepPreviousData: false,
      // staleTime: 5 * 60 * 1000,
      onError: (error) => {
        if (window.appsignal) {
          window.appsignal.sendError(error);
        }
        console.error(error);
      },
    },
  },
});

export default function ReactQueryClientProvider({ children, showDevTools }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevTools ? <ReactQueryDevtools position="bottom-right" /> : null}
    </QueryClientProvider>
  );
}
